import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Layout from "../components/Layout";
import Seo from "../components/Seo";

const IndexPage = () => (
  <Layout>
    <Seo title="Welcome" />
	<h2>Welcome</h2>
	<div className="main--centerwrapper">
		<StaticImage
		src="../images/photos/pressRes/rebecca1.jpg"
		alt="Jesse Rivest press image"
		placeholder="blurred"
		layout="constrained"
		className="main--centered"
		imgClassName="img--bordered-small"
		width={500}
		/>
	</div>
	<h3>I'm Jesse Rivest</h3>
	<p>
		Thanks for stopping by and taking a break from social media.
		If you're new here, get started at either
		my <Link to="/events/">shows</Link> or <Link to="/music/">music</Link> pages.<br />
		Also consider my <a href="//bit.ly/email-list-JR">mailing list</a> (frequency: 3 to 4 months)
		or my new, payment-optional <a href="//patreon.com/jesserivest/">Patreon</a> (frequency: fortnightly).
	</p>

	<div className="main--centerwrapper p">
		<StaticImage
		src="../images/catalog artwork/JRIVEST01 Seventeen Oh-Two Oh-Six - 20 yrs.png"
		alt="Jesse Rivest - Seventeen Oh-Two Oh-Six - cover - 20 years"
		placeholder="blurred"
		layout="constrained"
		className="main--centered"
		imgClassName="img--bordered-small"
		width={500}
		/>
	</div>
	<h3>Acknowledging twenty years</h3>
	<p>
		May 2026 marks twenty years of <span className="italic">Seventeen Oh-Two Oh-Six</span>. Time flies!
		I made a video or three for the occasion.
		Get started at the <Link to="/news/202605/#1">news page for May</Link>.
	</p>
  </Layout>
);

export default IndexPage;
